import {makeAutoObservable, observable, computed, action} from "mobx";
import * as mobx from 'mobx';

class StoreBrands {

    brands = [{
        name: 'japantky',
        display_value: 'JapanTKY',
        section: 'brands'
    },{
        name: 'ooon',
        display_value: 'Ooon Cashmere',
        section: 'brands'
    },{
        name: 'marylise',
        display_value: 'Marylise',
        section: 'bridal'
    },{
        name: 'rembo',
        display_value: 'Rembo Styling',
        section: 'bridal'
    },{
        name: 'inti',
        display_value: 'Inti Knitwear',
        section: 'brands'
    },{
        name: 'infinit',
        display_value: 'Infinit Barcelona',
        section: 'bridal'
    }]

    constructor() {

    }

}

export default StoreBrands;